import axios from "axios";
import { THREDDS_MSP } from "@/config/data-providers.js";

const PARSER = new DOMParser();

const getPathFromLatest = async url => {
  const res = await axios.get(url);
  const path = _extractPath(res.data);
  return path;
};

const getProductDataSerie = async params => {
  const urlLatest = params.baseUrl + params.latestPath;
  const pathToFile = await getPathFromLatest(urlLatest);
  const queryString = _getQueryString(
    params.variable.shortName,
    params.date,
    params.point
  );
  const fullUrl = `${params.baseUrl}${pathToFile}${queryString}`;

  const res = await axios.get(fullUrl);
  const dataSerie = _extractDataSerie(res.data, params.variable);
  return dataSerie;
};

const getSpeedFromComponents = async (u, v) => {
  return Math.sqrt(u * u + v * v);
};

const getProductDateLimits = async (baseUrl, latestPath) => {
  const urlLatest = baseUrl + latestPath;
  const pathToFile = await getPathFromLatest(urlLatest);
  const res = await axios.get(`${baseUrl}${pathToFile}/dataset.xml`);
  const dateLimits = _extractDateLimits(res.data);
  return dateLimits;
};

function _extractDataSerie(xmlString, variable) {
  const xmlDoc = PARSER.parseFromString(xmlString, "text/html");
  const serie = [];
  const points = xmlDoc.getElementsByTagName("point");

  for (const point of points) {
    let timeStamp = 0;
    let value = 0;

    for (const data of point.childNodes) {
      switch (data.getAttribute("name")) {
        case "date":
          timeStamp = new Date(data.textContent).getTime();
          break;
        case variable.shortName:
          value = data.textContent;
          break;
      }
    }
    const realValue = _getRealValue(
      value,
      variable.scaleFactor,
      variable.offset
    );
    serie.push([timeStamp, realValue]);
  }
  return serie;
}

function _extractDateLimits(xmlString) {
  const xmlDoc = PARSER.parseFromString(xmlString, "text/html");
  const beginTag = xmlDoc.getElementsByTagName("begin")[0];
  const endTag = xmlDoc.getElementsByTagName("end")[0];

  return {
    ini: beginTag.textContent,
    end: endTag.textContent
  };
}

function _getRealValue(value, scaleFactor, offset) {
  return value * scaleFactor + offset;
}

function _extractPath(xmlString) {
  const xmlDoc = PARSER.parseFromString(xmlString, "text/html");
  var base = xmlDoc.getElementsByName("ncss")[0].attributes.base.value;
  var urlPath = xmlDoc.getElementsByTagName("dataset")[0].attributes.urlPath
    .value;
  return `${base}${urlPath}`;
}

function _getQueryString(variable, date, point) {
  /* Sample request
      http://193.144.208.177:8080/thredds/ncss/grid/copernicus/CMEMS/GLOBAL_REANALYSIS_PHY_001_030.nc?var=thetao&latitude=43.644026&longitude=-3.955078&time_start=2000-01-01T12%3A00%3A00Z&time_end=2005-12-27T12%3A00%3A00Z&vertCoord=&accept=xml
  */
  const varQuery = `var=${variable}`;
  const dateQuery = `time_start=${date.ini}&time_end=${date.end}`;
  const placeQuery = `latitude=${point.lat}&longitude=${point.lon}`;

  return `?${varQuery}&${dateQuery}&${placeQuery}&vertCoord=0.49402499198913574&accept=xml`;
}

/* THREDDS MSP */

const getSuitability = async params => {
  const queryString = `?var=${params.variableName}&latitude=${
    params.point.lat
  }&longitude=${params.point.lon}`;
  const url = `${THREDDS_MSP.ncssUrl}${params.path}${queryString}`;

  const res = await axios.get(url);
  const value = _extractVariableValue(res.data, params.variableName);
  return value;
};

function _extractVariableValue(xmlString, varName) {
  const xmlDoc = PARSER.parseFromString(xmlString, "text/html");
  const variableTag = xmlDoc.getElementsByName(varName)[0];
  return variableTag.textContent;
}

export {
  getPathFromLatest,
  getProductDataSerie,
  getProductDateLimits,
  getSpeedFromComponents,
  getSuitability
};
